<template>
    <div>
        <div class="cstm-tab-holder">
            <div
                class="cstm-unique-tab flex mb-4"
            >
                <div style="width: calc(100% - 105px)" class="flex flex-wrap">
                    <div
                        class="tab-name"
                        :class="{ activeTab: template }"
                        @click="tab('template')"
                    >
                        Template
                    </div>
                    <div
                        class="tab-name"
                        :class="{ activeTab: courseWork }"
                        @click="tab('courseWork')"
                    >
                        Coursework
                    </div>
                </div>
            </div>
            <div v-if="template">
              <Template />
            </div>

            <div v-if="courseWork">
              <CourseWork />
            </div>
        </div>
    </div>
</template>

<script>
import Template from './components/Template/index.vue'
import CourseWork from './components/CourseWork/index.vue'

export default {
  name: 'Coursework',
  components: {
    Template,
    CourseWork
  },
  data () {
    return {
      template: true,
      courseWork: false,
      tabs: ['#template', '#courseWork']   
    }
  },
  mounted() {
    this.tab(this.$route.hash.substring(1))
  },
  methods: {
    tab (type) {
      if (type === 'template') {
        this.template = true
        this.courseWork = false
      } else if (type === 'courseWork') {
        this.template = false
        this.courseWork = true
      }
    }
  }
}
</script>